import { ProfessionalSchedule } from '@medprev-web-app/api-graphql-client';

export interface ProfessionalLocation {
  city: string;
  state: string;
  cityState: string;
}

export interface LocationAddress {
  neighborhood: string;
  socialName: string;
  distance: string;
}

export interface InPersonLocations {
  [cityState: string]: LocationAddress[];
}

export function extractProfessionalLocation(
  inPersonSchedules: ProfessionalSchedule[],
): ProfessionalLocation | null {
  if (!Array.isArray(inPersonSchedules) || inPersonSchedules.length === 0) {
    return null;
  }

  const firstSchedule = inPersonSchedules[0];
  const city = firstSchedule?.partner?.facility?.city;
  const state = firstSchedule?.partner?.facility?.state;

  if (!city || !state) {
    return null;
  }

  return {
    city,
    state,
    cityState: `${city} - ${state}`,
  };
}
export function transformInPersonSchedules(
  inPersonSchedules: ProfessionalSchedule[],
): InPersonLocations {
  if (!Array.isArray(inPersonSchedules) || inPersonSchedules.length === 0) {
    return {};
  }

  return inPersonSchedules.reduce<InPersonLocations>((result, item) => {
    const key = `${item.partner.facility!.city} - ${item.partner.facility!.state}`;

    if (!result[key]) {
      result[key] = [];
    }

    const distanceInKm = Number(item.partner.distance || 0);
    const locationAddress: LocationAddress = {
      neighborhood: item.partner.facility!.neighborhood || '',
      socialName: item.partner.socialName || '',
      distance: item.partner.distance ? `  • a ${distanceInKm.toFixed(1).replace('.', ',')}km` : '',
    };

    if (!result[key].some((address) => address.socialName === locationAddress.socialName)) {
      result[key].push(locationAddress);
    }

    return result;
  }, {});
}
